<template>
  <form-group class="checkbox-group-input"
              :label="label"
              :errors="internalErrors"
              @focus="focus">
    <label v-for="(option, index) in options"
           class="checkbox-group-input__option"
           :class="{ 'uk-margin-small-left': inline && !isFirstItem(index),
                     'checkbox-group-input__option--inline': inline,
                     'checkbox-group-input__option--block': !inline }">
      <input :name="groupName"
             class="uk-checkbox"
             type="checkbox"
             :value="option.value"
             :checked="isSelected(option.value)"
             :disabled="disabled"
             @change="onInput">
      {{option.label}}
    </label>
  </form-group>
</template>

<script>
import { includes, pull } from 'lodash';
import InputWithOptions from '@/mixins/InputWithOptions';
import uuid from 'uuid/v4';

export default {
  name: 'checkbox-group-input',
  mixins: [InputWithOptions],
  props: {
    inline: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    groupName() {
      return uuid();
    },
  },
  methods: {
    isFirstItem(index) {
      return index === 0;
    },
    focus() {
      // not supported
    },
    onInput(event) {
      const value = event.target.value;
      const values = (this.internalValue || []).slice(0);
      if (this.isSelected(value)) {
        pull(values, value);
      } else {
        values.push(value);
      }
      this.clearErrors();
      this.$emit('input', values);
      this.$emit('change', values);
    },
    isSelected(value) {
      if (!this.internalValue) return false;
      return includes(this.internalValue, value);
    },
  },
};
</script>

<style lang="scss" scoped>
.checkbox-group-input__option--block {
  display: block;
}
</style>



// WEBPACK FOOTER //
// CheckboxGroupInput.vue?b7ec33e2